import { Expression } from './Expression.js';
export class PostExpression extends Expression {
    constructor(value) {
        super();
        this.value = value;
    }
    getValue() {
        return this.value;
    }
    evaluate(visitor, localVariables) {
        return this.getValue().evaluate(visitor, localVariables);
    }
}
//# sourceMappingURL=PostExpression.js.map